import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { closePopover } from '../../actions/popover'
import { me } from '../../initial_state'
import {
	updateRole,
	createRemovedAccount,
} from '../../actions/groups'
import PopoverLayout from './popover_layout'
import List from '../list'

class GroupMemberOptionsPopover extends React.PureComponent {

  handleOnRemoveFromGroup = () => {
	  this.props.onCreateRemovedAccount(this.props.groupId, this.props.accountId)
  }

  handleOnUpdateRole = (role) => {
	  this.props.onUpdateRole(this.props.groupId, this.props.accountId, role)
  }

  handleOnClosePopover = () => {
    this.props.onClosePopover()
  }

  render() {
    const { group, isAdmin, isMod, accountId, isXS } = this.props

    // no actions on myself
    if (accountId === me || !group) return <div />

    const roles = group.get('admin_account_roles')
    
    if (!roles) return <div />

    const accountIsAdmin = roles.get(accountId) === 'admin'
	  const accountIsMod = roles.get(accountId) === 'moderator'
    const accountIsNormal = !accountIsAdmin && !accountIsMod

    const listItems = []

    if (isAdmin || isMod) {
      if (accountIsNormal) {
        // allow admins, mods to remove normal members
        listItems.push({
          hideArrow: true,
          icon: 'block',
          title: 'Remove from group',
          subtitle: 'User will not be able to re-join',
          onClick: this.handleOnRemoveFromGroup,
        })
      } else {
        // allow ONLY admins to remove anyone
        listItems.push({
          hideArrow: true,
          icon: 'block',
          title: 'Remove from group',
          subtitle: 'User will not be able to re-join',
          onClick: this.handleOnRemoveFromGroup,
        })
      }
    }

    if (isAdmin) {
      listItems.push({})
    
      // Allow only admins to promote/demote
      if (!accountIsMod) {
        listItems.push({
          hideArrow: true,
          icon: 'group',
          title: 'Make group moderator',
          subtitle: 'Moderators can approve and remove posts. Can remove accounts that are not already moderators or admins.',
          onClick: () => this.handleOnUpdateRole('moderator'),
        })
      } else {
        listItems.push({
          hideArrow: true,
          icon: 'group',
          title: 'Remove group moderator',
          subtitle: 'Demote this user to a normal group member.',
          onClick: () => this.handleOnUpdateRole(null),
        })
      }
      if (!accountIsAdmin) {
        listItems.push({
          hideArrow: true,
          icon: 'group',
          title: 'Make group admin',
          subtitle: 'Admins can perform all actions for a group such as updating settings, promoting and demoting members and removing posts.',
          onClick: () => this.handleOnUpdateRole('admin'),
        })
      } else {
        listItems.push({
          hideArrow: true,
          icon: 'group',
          title: 'Remove group admin',
          subtitle: 'Demote this user to a normal group member.',
          onClick: () => this.handleOnUpdateRole(null),
        })
      }
    }

    return (
      <PopoverLayout
        width={400}
        isXS={isXS}
        onClose={this.handleOnClosePopover}
      >
        <List
          scrollKey='group_options'
          items={listItems}
          size={isXS ? 'large' : 'small'}
        />
      </PopoverLayout>
    )
  }

}

const mapStateToProps = (state, { groupId }) => {
	const group = state.getIn(['groups', groupId])
	const relationships = state.getIn(['group_relationships', groupId])

	return {
		group,
		groupId,
		relationships,
		isAdmin: relationships ? relationships.get('admin') : false,
		isMod: relationships ? relationships.get('moderator') : false,
	}
}

const mapDispatchToProps = (dispatch) => ({
  onUpdateRole(groupId, accountId, type) {
    dispatch(closePopover())
    dispatch(updateRole(groupId, accountId, type))
  },
  onCreateRemovedAccount(groupId, accountId) {
    dispatch(closePopover())
    dispatch(createRemovedAccount(groupId, accountId))
  },
  onClosePopover:() => dispatch(closePopover()),
})

GroupMemberOptionsPopover.defaultProps = {
  accountId: PropTypes.string.isRequired,
  groupId: PropTypes.string.isRequired,
  isXS: PropTypes.bool,
  onClosePopover: PropTypes.func.isRequired,
  onCreateRemovedAccount: PropTypes.func.isRequired,
  onUpdateRole: PropTypes.func.isRequired,
  isModerator: PropTypes.bool,
  isAdmin: PropTypes.bool,
  isAccountModerator: PropTypes.bool,
}

export default connect(mapStateToProps, mapDispatchToProps)(GroupMemberOptionsPopover)